import {Inject, Injectable} from '@angular/core';
import {AuthService, CurrentUser} from 'app/core/services/auth.service';
import {REDIRECT, Redirect} from 'app/core/helpers/redirect';
import {I18NextPipe} from 'angular-i18next';

@Injectable()
export class AcceptTermsService {
    constructor(
        private auth: AuthService,
        private i18next: I18NextPipe,
        @Inject(REDIRECT) private RedirectPage: Redirect
    ) {}

    public checkTerms() {
        this.auth.fetchCurrentUser().then((user: CurrentUser) => {
            if (location.pathname.startsWith('/auth-bridge') || !user) {
                return;
            }

            if (!user.isTermsChecked) {
                this.RedirectPage(this.i18next.transform('links.terms'));
                return;
            }
        });
    }
}
